import { render, staticRenderFns } from "./FitText.vue?vue&type=template&id=3e63c0ea"
import script from "./FitText.vue?vue&type=script&lang=js"
export * from "./FitText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports